/**
 * PLP grid-density A/B test telemetry — flag "plp-product-rows".
 *
 * Loaded only on collection templates (gated in theme.liquid). Fires:
 *   - plp_grid_viewed     when the product listing page is viewed
 *   - plp_product_clicked when a product card is clicked
 *
 * Every event carries `plp_variant: 'control' | 'test'`. If the flag never
 * resolves the user is treated as `control`, matching the visual fallback
 * (no body class -> existing 2-column grid). Events use a raw fetch to
 * PostHog's capture endpoint (same approach as the flag fetch in
 * theme.liquid) and fail silently — telemetry must never break the page.
 *
 * Note: the Maiden Home PLP has no add-to-cart UI (quick_add: 'none'), so
 * there is no add-to-cart-from-PLP event here.
 */
(function () {
  var POSTHOG_KEY = 'phc_IMjdKGYheEDrUMyGLgthEcORfl2gEqblfAdoX4OJ618';
  var POSTHOG_HOST = 'https://us.i.posthog.com';
  var FLAG = 'plp-product-rows';

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  // Resolve the active variant from the body class set by initAbTest()
  // (or the ?plp_variant= / sessionStorage override). Defaults to 'control'
  // when unresolved so telemetry matches what the user sees.
  function getVariant() {
    var cls = document.body.className || '';
    if (cls.indexOf('ab-test--' + FLAG + '--test') !== -1) return 'test';
    try {
      var stored = window.sessionStorage.getItem('plpRowsVariant');
      if (stored === 'test') return 'test';
    } catch (e) {}
    return 'control';
  }

  function send(eventName, properties) {
    try {
      var distinctId = window.localStorage.getItem('userUUID') || 'anonymous';
      fetch(POSTHOG_HOST + '/i/v0/e/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          api_key: POSTHOG_KEY,
          event: eventName,
          distinct_id: distinctId,
          properties: Object.assign(
            {
              plp_variant: getVariant(),
              $current_url: window.location.href,
              // Same reserved names as the web pixel (MH-1385). This path
              // posts straight to PostHog and bypasses the RudderStack
              // transformations, so it needs its own copy.
              $referrer: document.referrer || '$direct',
              $referring_domain: document.referrer
                ? new URL(document.referrer).hostname
                : '$direct',
            },
            properties || {}
          ),
          timestamp: new Date().toISOString(),
        }),
      }).catch(function () {});
    } catch (e) {
      /* fail silently */
    }
  }

  // initAbTest() adds the body class asynchronously after the PostHog flag
  // call resolves. Wait briefly so the page-view variant is accurate, then
  // fall back to control.
  var attempts = 0;
  (function whenVariantReady() {
    var resolved = (document.body.className || '').indexOf('ab-test--' + FLAG + '--') !== -1;
    if (resolved || attempts >= 25) {
      send('plp_grid_viewed', {
        collection_handle: (window.location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || null,
        product_count: grid.querySelectorAll('.collection-grid__item').length,
      });
      return;
    }
    attempts += 1;
    setTimeout(whenVariantReady, 200);
  })();

  grid.addEventListener(
    'click',
    function (e) {
      var item = e.target.closest('.collection-grid__item');
      if (!item || !grid.contains(item)) return;

      var link = item.querySelector('a[href*="/products/"]');
      send('plp_product_clicked', {
        product_handle: link
          ? (link.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1] || null
          : null,
        position: Array.prototype.indexOf.call(grid.querySelectorAll('.collection-grid__item'), item) + 1,
      });
    },
    true
  );
})();
